import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    id: string,
    name: string,
}

interface Variables {
    input: {
        company: string,
        country: string,
        email: string,
        industry: string,
        name: string,
        phone: string,
    }
}

export const CREATE_LEAD: TypedDocumentNode<Result, Variables> = gql`
    mutation CreateLead($input: CreateLeadInput){
        createLead (input: $input) {
            id
            name
            status
        }
    }       
`
